// Groups are derived from their permitted descendants, never from a separate permission list.
export const buildMenu = (menus, permissions = []) => {
    const allowed = new Set(permissions);

    const filterMenus = items => items.flatMap(item => {
        if (item.visible === false) return [];

        const options = filterMenus(item.options || []);
        const isGroup = Boolean(item.options?.length);
        if (isGroup ? options.length === 0 : !allowed.has(item.permissionName)) return [];

        return [{ ...item, options }];
    }).sort((a, b) => a.order - b.order);

    return filterMenus(menus);
};
